{
  "checks": {
    "chip": {
      "fail_one": "Checks: {{count}} fails",
      "fail_other": "Checks: {{count}} fail",
      "failed": "Checks: can't load",
      "hint": "Reasoning, consistency, shapes and competency questions, run on this version",
      "notChecked_one": "Checks: {{count}} not checked",
      "notChecked_other": "Checks: {{count}} not checked",
      "notRun": "Checks: not run",
      "pass": "Checks: all pass",
      "running": "Checks: running…"
    },
    "close": "Close the checks",
    "failsHere": "A check fails here",
    "process": "Process checks",
    "running": "Running the checks…",
    "title": "Checks"
  },
  "children": "Children",
  "chooseVersion": "Choose a version…",
  "collapseEntity": "Collapse {{name}}",
  "copyModule": "Copy the exact reference of this ontology module",
  "cycleReference": "Cycle",
  "declaredIn": "In ontology module",
  "definitions": "Definitions",
  "details": "Details",
  "displayMode": "View",
  "domain": "Applies to (domain)",
  "empty": {
    "body": "This version has no ontology module. Its terms appear here once a change set adds one.",
    "inherits": "This project has no ontology module of its own yet.",
    "title": "No data model yet"
  },
  "entityTypeChoice": "Kind of entity",
  "entityTypeHints": {
    "annotationProperties": "Notes on terms, such as labels and definitions",
    "classes": "Kinds of things, from general to specific",
    "dataProperties": "Values a thing has, such as a date or a name",
    "individuals": "Single named things the data model itself declares, such as fixed values",
    "objectProperties": "How one thing relates to another",
    "relations": "Which classes the object properties connect"
  },
  "entityTypes": {
    "annotationProperties": "Annotation properties",
    "classes": "Classes",
    "dataProperties": "Data properties",
    "individuals": "Named individuals",
    "objectProperties": "Object properties",
    "relations": "Relation map"
  },
  "exactReference": "Copy the exact reference of this version",
  "expandEntity": "Expand {{name}}",
  "incomingRelations": "Incoming relations",
  "labels": "Labels",
  "latestVersion": "Latest",
  "loading": "Loading ontology…",
  "loadingTerm": "Loading the term…",
  "loadingVersions": "Loading versions…",
  "modules": {
    "all": "All ({{count}})",
    "allHint": "Show the terms of the project's own ontology modules",
    "dmwBasis": "DMW basis",
    "library": "Pinned library",
    "none": "This version has no ontology module.",
    "title": "Ontology modules",
    "turtleOf": "Turtle of the ontology module {{name}}"
  },
  "noChildren": "No children.",
  "noDefinitions": "No definitions.",
  "noDomain": "Not restricted.",
  "noEntities": "No entries found.",
  "noEntitySelected": "Nothing selected.",
  "noIncomingRelations": "No incoming relations.",
  "noLabels": "No labels.",
  "noOutgoingRelations": "No outgoing relations.",
  "noParents": "No parents.",
  "noProjectBody": "The ontology belongs to a project. Choose one in the top bar.",
  "noProjectTitle": "Choose a project first",
  "noRange": "Not restricted.",
  "noVersionBody": "Nothing here yet. The ontology arrives with the project's first merged change set.",
  "noVersionTitle": "No ontology version yet",
  "olderVersion": "Older version, read only",
  "openEntity": "Open {{name}}",
  "outgoingRelations": "Outgoing relations",
  "pages": {"release": "Release", "result": "Result"},
  "parents": "Parents",
  "predicates": {
    "altLabel": "other label",
    "comment": "comment",
    "definition": "definition",
    "editorialNote": "editorial note",
    "hiddenLabel": "hidden label",
    "label": "label",
    "prefLabel": "preferred label",
    "scopeNote": "scope note"
  },
  "proposals": {
    "addDefinition": "Add definition",
    "addLabel": "Add label",
    "addSubclass": "Add subclass",
    "definitionText": "Definition",
    "existingChangeSet": "Add to an open change set",
    "labelText": "Label",
    "language": "Language",
    "languageHint": "A language tag such as en or de; leave empty for none.",
    "latestOnly": "Changes are proposed on the latest version. Switch to it to propose one.",
    "newChangeSet": "New change set",
    "newIri": "IRI of the new class",
    "noOpenChangeSets": "You have no open change set in this project.",
    "othersChangeSets": "Others' change sets (as curator)",
    "ownChangeSets": "My change sets",
    "preview": "What changes",
    "problems": {
      "empty": "Enter a text.",
      "iri": "Enter an absolute IRI without spaces, such as http://example.org/terms#Abbot.",
      "iriTaken": "A term with this IRI exists already.",
      "language": "This is not a valid language tag.",
      "unchanged": "The text is unchanged."
    },
    "propose": "Propose",
    "subtitle": "Your change becomes part of a change set. Curators review it before it enters the ontology.",
    "target": "Change set",
    "title": "Title of the change set",
    "titles": {
      "addLabel": "Add a label to {{name}}",
      "addSubclass": "Add a subclass of {{name}}",
      "editDefinition": "Edit the definition of {{name}}",
      "edits": "Edit {{name}}",
      "renameLabel": "Rename a label of {{name}}"
    }
  },
  "range": "Values (range)",
  "raw": "Turtle",
  "relationProperty": "Relation: {{name}}",
  "relationSource": "from",
  "relationTarget": "to",
  "releases": {"count_one": "{{count}} release", "count_other": "{{count}} releases"},
  "resizePanels": "Resize hierarchy and details",
  "restrictions": {
    "axioms": {
      "equivalent_class": "Something is a {{name}} exactly when it …",
      "subclass_of": "Every {{name}} …"
    },
    "classExpression": "a nested class expression (see the Turtle below)",
    "constraints": {
      "all_values_from": "only",
      "exact_cardinality": "exactly {{count}}",
      "has_value": "the value",
      "max_cardinality": "at most {{count}}",
      "min_cardinality": "at least {{count}}",
      "some_values_from": "at least one"
    },
    "none": "No restrictions.",
    "title": "Restrictions",
    "values": "values"
  },
  "search": {
    "label": "Find a term",
    "none": "No term matches.",
    "placeholder": "Label or IRI",
    "searching": "Searching…"
  },
  "slice": {
    "close": "Show the whole data model",
    "editInReview": "Edit in the review",
    "loading": "Loading the slice…",
    "missingBody": "The link names a Run entry that holds no ontology terms, or the Run can't be read.",
    "missingTitle": "No slice here",
    "now": "Data model now",
    "of_one": "{{count}} term of the slice from",
    "of_other": "{{count}} terms of the slice from",
    "proposed": "As proposed",
    "wholeBeside": "Whole data model beside"
  },
  "structured": "Structured",
  "termKinds": {
    "annotation_property": "Annotation property",
    "class": "Class",
    "datatype_property": "Data property",
    "individual": "Named individual",
    "object_property": "Object property"
  },
  "termTurtle": "Turtle of this term",
  "title": "Data model",
  "usage": {
    "inTheData": "In the data",
    "none": "Nothing uses this term in this version.",
    "title": "Where it is used",
    "via": "through"
  },
  "version": "Version",
  "versions": "Versions"
}
